'use client';

import { SignedIn, SignedOut } from '@clerk/nextjs';
import { UserIcon } from 'lucide-react';
import Link from 'next/link';

import { ProfileButton } from '@components/common/profile-button';
import { useHeaderStore } from '@lib/stores/useHeaderStore';
import { Separator } from '@components/common/separator';
import { useResize } from '@lib/hooks/useResize';
import { Routes } from '@lib/routes';

export function UpperHeaderProfile() {
  const setOpenSheet = useHeaderStore((state) => state.setOpenSheet);
  const { width } = useResize();
  const sm = width >= 640;

  return (
    <>
      <SignedIn>
        <ProfileButton
          anchor='bottom end'
          showName={sm}
          isDark
          links={[
            {
              label: 'My Account',
              href: Routes.account,
              onClick: () => setOpenSheet(false),
              icon: UserIcon,
            },
          ]}
        />
      </SignedIn>

      <SignedOut>
        <div className='flex-end sm:gap-x-2 text-xs sm:text-sm font-medium text-primary-foreground'>
          <Link
            href={Routes.signUp}
            className='hover:text-primary-foreground/80 text-right text-wrap'
          >
            Join
          </Link>
          <Separator
            aria-hidden='true'
            className='mx-1.5 sm:mx-2 h-6 w-px bg-gray-500 lg:mx-4'
          />
          <Link
            href={Routes.signIn}
            className='hover:text-primary-foreground/80 text-right text-nowrap'
          >
            Sign in
          </Link>
        </div>
      </SignedOut>
    </>
  );
}
